export const EducativeCarouselStyles = {
  mainContainer: {
    backgroundColor: '#FFFFFF',
    height: 'auto',
    maxHeight: '100vh',
  },

  sliderIndicator: {
    position: 'relative',
    top: '-5vw',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '17px 31px 17px 16px',
    gap: '10px',
    '@media (max-width:600px)': {
      position: 'relative',
      top: '10px',
    },
  },

  sliderIndicatorItemActive: {
    borderRadius: '100px',
    padding: '0px 14px',
    height: '14px',
    backgroundColor: '#F58220',
  },

  sliderIndicatorItem: {
    borderRadius: '100px',
    padding: '0px 7px',
    height: '14px',
    backgroundColor: '#918282',
  },

  imgSize: {
    width: '100vw',
  },

  contentContainer1: {
    position: 'relative',
    top: '-5vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1000',
    marginBottom: '48px',
    '@media (max-width:600px)': {
      position: 'relative',
      top: '0vw',
      margin: '0px',
      padding: '0px 10px',
    },
  },

  contentContainer2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50vw',
    gap: '24px',
    '@media (max-width:600px)': {
      width: '100%',
      gap: '0px',
    },
  },

  para1: {
    font: 'normal 400 20px/22px Arial',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#808285',
    '@media (max-width:600px)': {
      marginBottom: '50px',
      width: '72vw',
    },
    '@media (max-width:300px)': {
      font: 'normal 400 16px/18px Arial',
    },
  },

  para2: {
    font: 'normal 800 48px/52px "TTNormsProBold"',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#000000',
    width: '150%',
    '@media (max-width:750px)': {
      width: '100%',
    },
    '@media (max-width:600px)': {
      marginBottom: '15px',
      width: '86vw',
    },
    '@media (max-width:330px)': {
      font: 'normal 800 38px/52px "TTNormsProBold"',
    },
  },

  subPara2: {
    font: 'normal 800 48px/52px "TTNormsProBold"',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#F5821F',
    '@media (max-width:330px)': {
      font: 'normal 800 38px/52px "TTNormsProBold"',
    },
  },

  para3: {
    font: 'normal 400 20px/22px Arial',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#000000',
    width: '44vw',
    textWrap: 'balance',
    '@media (max-width:600px)': {
      width: '72vw',
    },
    '@media (max-width:300px)': {
      font: 'normal 400 16px/18px Arial',
    },
  },
};
